import { createContext, useContext, useState, useEffect } from "react";

const dict = {
  fr: {
    "nav.home": "Accueil", "nav.channels": "Chaînes", "nav.search": "Explorer", "nav.partners": "Partenaires",
    "nav.about": "Qui sommes-nous",
    "nav.admin": "Admin", "nav.membership": "Adhésion",
    "search.placeholder": "Rechercher émissions, chaînes, tags...",
    "footer.tagline": "Diffusion depuis 2026",
    "footer.copyright": "© 2026 RBY Concept · Tous droits réservés",
    "newsletter.eyebrow": "Newsletter",
    "newsletter.title": "Restez branché sur la culture",
    "newsletter.body": "Nouvelles chaînes, battles, sessions live — recevez l'essentiel du réseau Fedevo 2.0 dans votre boîte.",
    "newsletter.placeholder": "votre@email.com",
    "newsletter.submit": "S'inscrire",
    "newsletter.success": "Merci ! Vous êtes inscrit à la newsletter Fedevo 2.0",
    "newsletter.fail": "Échec de l'inscription",
    "sponsors.eyebrow": "Soutenu par nos partenaires",
    "home.onair": "À l'antenne maintenant",
    "home.welcome": "Bienvenue sur Fedevo 2.0",
    "home.intro": "Une diffusion urbaine dédiée à la street culture — hip-hop, graff, break, DJ, beatbox et au-delà. Branchez-vous, sans abonnement, sans friction.",
    "home.tunein": "Accéder à la chaîne",
    "home.watchfull": "Voir en entier",
    "home.live": "Chaînes en direct",
    "home.all": "Toutes →",
    "home.trending": "Tendances de l'heure",
    "home.allchannels": "Toutes les chaînes",
    "live.tuning": "Branchement en cours...",
    "live.channel": "Chaîne",
    "live.live": "En direct",
    "live.next": "Suivant",
    "live.upnext": "À suivre · Programme",
    "live.now": "En lecture",
    "live.back": "← Toutes les chaînes",
    "live.audience": "Audience en direct",
    "live.watching": "regardent",
    "live.topcountries": "Top pays",
    "about.eyebrow": "Qui sommes-nous ?",
    "about.h1.part1": "Fédération Vaudaise du",
    "about.h1.hiphop": "Hip-Hop",
    "about.h1.part2": "& des Cultures Urbaines",
    "about.lead1": "Fondée en septembre 2010 par des intervenants locaux. Anciennement connue sous le nom de",
    "about.lead2": "— une organisation dédiée à la culture hip-hop et aux pratiques urbaines.",
    "about.stat.founded": "Année de fondation",
    "about.stat.years": "Années d'expérience",
    "about.stat.digital": "Actualisation digitale",
    "about.stat.talents": "Talents soutenus",
    "about.dna.eyebrow": "Notre ADN",
    "about.dna.text": "Rassembler, soutenir & mettre en valeur le meilleur de la culture urbaine.",
    "about.disciplines": "Disciplines",
    "about.d.rap": "Rap & Slam",
    "about.d.dance": "Danse & Break",
    "about.d.dj": "DJing",
    "about.d.graff": "Graffiti",
    "about.d.beat": "Beatmaking",
    "about.d.beatbox": "Beatbox",
    "about.p1": "Depuis sa fondation, l'organisation soutient et développe des artistes issus de la culture urbaine, avec l'appui d'institutions privées et publiques de premier plan.",
    "about.p2a": "L'union multidisciplinaire dans les cultures urbaines englobe les artistes —",
    "about.p2disciplines": "rappeurs, danseurs, DJ, graffeurs, beatmakers, beatboxers",
    "about.p2b": "— ainsi que des experts, des organismes et des entrepreneurs.",
    "about.p3": "Nombre d'entre eux travaillent dans le domaine de l'art et des cultures urbaines depuis plusieurs années, sans pour autant recevoir la reconnaissance due à leurs efforts, leurs talents et leurs aspirations.",
    "about.quote1a": "À la suite de nos modifications administratives et statutaires, la FVHHCU évolue pour devenir une association —",
    "about.quote1b": "indépendante financièrement",
    "about.quote1c": ", avec des fonds privés et des collaborations, et bénéficiant de plus de quinze ans d'expérience pratique.",
    "about.p4": "actualisée en 2020 et révisée pour l'ère digitale, vise à encourager les projets artistiques des jeunes tout en stimulant leur évolution personnelle. Elle s'investit aussi dans la promotion de leurs œuvres sur internet et à travers ses différents canaux de diffusion.",
    "about.goal.quote": "Rassembler pour mettre en valeur le meilleur de notre culture.",
    "about.goal.label": "Notre objectif",
    "about.cta.title": "Rejoignez le mouvement",
    "about.cta.body": "Soutenez l'association, diffusez votre univers, ou devenez partenaire. Chaque geste compte pour la culture urbaine.",
    "about.cta.membership": "Devenir membre — 5 €",
    "about.cta.partners": "Voir nos partenaires",
  },
  en: {
    "nav.home": "Home", "nav.channels": "Channels", "nav.search": "Browse", "nav.partners": "Partners",
    "nav.about": "About",
    "nav.admin": "Admin", "nav.membership": "Membership",
    "search.placeholder": "Search shows, channels, tags...",
    "footer.tagline": "Broadcasting since 2026",
    "footer.copyright": "© 2026 RBY Concept · All rights reserved",
    "newsletter.eyebrow": "Newsletter",
    "newsletter.title": "Stay tuned to the culture",
    "newsletter.body": "New channels, battles, live sessions — get the essentials of the Fedevo 2.0 network straight to your inbox.",
    "newsletter.placeholder": "your@email.com",
    "newsletter.submit": "Subscribe",
    "newsletter.success": "Thanks! You're subscribed to the Fedevo 2.0 newsletter",
    "newsletter.fail": "Subscription failed",
    "sponsors.eyebrow": "Backed by our partners",
    "home.onair": "On Air Now",
    "home.welcome": "Welcome to Fedevo 2.0",
    "home.intro": "A curated urban broadcast for street culture — hip-hop, graff, break, DJ, beatbox and beyond. Tune in, no subscriptions, no friction.",
    "home.tunein": "Tune Into Channel",
    "home.watchfull": "Watch Full",
    "home.live": "Live Channels",
    "home.all": "All →",
    "home.trending": "Trending This Hour",
    "home.allchannels": "All Channels",
    "live.tuning": "Tuning in...",
    "live.channel": "Channel",
    "live.live": "Live",
    "live.next": "Next",
    "live.upnext": "Up Next · Schedule",
    "live.now": "Now Playing",
    "live.back": "← All Channels",
    "live.audience": "Live Audience",
    "live.watching": "watching",
    "live.topcountries": "Top countries",
    "about.eyebrow": "About us",
    "about.h1.part1": "Vaud Federation of",
    "about.h1.hiphop": "Hip-Hop",
    "about.h1.part2": "& Urban Cultures",
    "about.lead1": "Founded in September 2010 by local activists. Formerly known as",
    "about.lead2": "— an organization dedicated to hip-hop culture and urban practices.",
    "about.stat.founded": "Year founded",
    "about.stat.years": "Years of experience",
    "about.stat.digital": "Digital revamp",
    "about.stat.talents": "Talents supported",
    "about.dna.eyebrow": "Our DNA",
    "about.dna.text": "Gather, support & showcase the best of urban culture.",
    "about.disciplines": "Disciplines",
    "about.d.rap": "Rap & Spoken word",
    "about.d.dance": "Dance & Breaking",
    "about.d.dj": "DJing",
    "about.d.graff": "Graffiti",
    "about.d.beat": "Beatmaking",
    "about.d.beatbox": "Beatbox",
    "about.p1": "Since its founding, the organization has supported and developed artists from urban culture, backed by leading private and public institutions.",
    "about.p2a": "This multidisciplinary union in urban cultures brings together artists —",
    "about.p2disciplines": "rappers, dancers, DJs, graffiti writers, beatmakers, beatboxers",
    "about.p2b": "— as well as experts, organisations and entrepreneurs.",
    "about.p3": "Many of them have worked in art and urban cultures for years without receiving the recognition their efforts, talents and ambitions deserve.",
    "about.quote1a": "Following our administrative and statutory changes, the FVHHCU is evolving into an association —",
    "about.quote1b": "financially independent",
    "about.quote1c": ", with private funding and collaborations, and drawing on more than fifteen years of hands-on experience.",
    "about.p4": "refreshed in 2020 and rebuilt for the digital era, aims to foster the artistic projects of young creators while nurturing their personal growth. It also actively promotes their work online and through its various broadcasting channels.",
    "about.goal.quote": "Gather to showcase the best of our culture.",
    "about.goal.label": "Our goal",
    "about.cta.title": "Join the movement",
    "about.cta.body": "Support the association, broadcast your world, or become a partner. Every contribution matters for urban culture.",
    "about.cta.membership": "Become a member — €5",
    "about.cta.partners": "See our partners",
  },
};

const I18nContext = createContext({ lang: "fr", t: (k) => k, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("fv_lang") || "fr");
  useEffect(() => { localStorage.setItem("fv_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (key) => dict[lang]?.[key] ?? dict.fr[key] ?? key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
